<template>
  <div
    class="card__response card-body border-bottom border-medium"
    :class="{ 'border-top ': isShowBoarder }"
  >
    <!-- Date -->
    <div class="response__date text__response-time">
      {{ dateString }}
    </div>

    <!-- User profile -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <BaseUserProfile :user-name="userFullName" :size="'lg'">
        <template slot="name">
          <div class="ml-2">
            <div class="text-dark">
              {{ userFullName }}
            </div>
          </div>
        </template>
      </BaseUserProfile>
    </div>

    <!-- Content -->
    <div class="response__content">
      <div v-safe-html="postResponse.description" class="text-pre-wrap text__description"></div>
    </div>

    <!-- attachments -->
    <BaseFilesList :attachments="postResponse.attachments" class="mt-3 file-list__submission" />
  </div>
</template>

<script>
import { BaseUserProfile, BaseFilesList } from '@/components/base-components';
import { datetimeMixin } from '@/mixins';

export default {
  components: {
    BaseUserProfile,
    BaseFilesList
  },

  mixins: [datetimeMixin],

  props: {
    postResponse: {
      type: Object,
      default: () => {}
    },

    isShowBoarder: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    dateString() {
      return `
        ${this.formatedDatetime(this.postResponse.created_at, 'MMM D, YYYY hh:mma ')} 
        ${this.cityTimezone} time`;
    },

    userFullName() {
      return `${this.postResponse.user.firstname} ${this.postResponse.user.lastname}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.response__date {
  color: rgba(7, 9, 25, 0.5);
}

.response__content {
  margin-left: 4rem;
}

.file-list__submission {
  margin-left: 3.5rem;
}
</style>
